module.exports = __webpack_public_path__ + "img/dishwasher.fa6df6f5.svg";